<template>
	<div id="app">
		<div class="image-wrapper" v-show="isWeb == false">
			<img src="@/static/img/screenshot.webp" alt="" />
		</div>
		<!-- 头部组件 -->
		<Header v-if="$store.state.header && isLoadSysData" v-show="isWeb == true" />
		<!-- 中间内容组件 -->
		<div v-if="isLoadSysData" v-show="isWeb == true">
			<router-view class="main_box" v-if="isRouterAlive" />
		</div>

		<!-- 底部组件 -->
		<Footer v-show="isWeb == true" v-if="$store.state.footer && isLoadSysData" />
	</div>
</template>

<script>
import Header from "@/components/header/Header.vue";
import Footer from "@/components/footer/Footer.vue";
import { SysKey, exLoadSystemConfig } from "./util/sysconfig";
import { mapState } from "vuex";
import { getThirdGameCategory, getThirdGame, getUserFavoritesLotteryList } from "./util/getdata";

export default {
	name: "App",
	components: {
		Header,
		Footer,
	},
	provide() {
		return {
			reload: this.reload,
		};
	},
	data() {
		return {
			isLoadSysData: false,
			isRouterAlive: true,
			isWeb: false,
		};
	},
	computed: {
		...mapState({
			footer: state => state.footer,
		}),
	},
	created() {
		console.log("BD");
		let self = this;
		exLoadSystemConfig().then(data => {
			if (!data) return;

			if (data.IsSucess) {
				window.systemData = data.Data;
			}
			this.isLoadSysData = true;

			function goPAGE() {
				if (window.innerWidth < 700) {
					setTimeout(() => {
						window.location.href = window.location.origin + "/wap";
						self.isWeb = false;
					});
				} else {
					self.isWeb = true;
				}
			}

			goPAGE();
			// 修改网站标题
			document.title = SysKey("SysName").SysValue;
		});

		getThirdGameCategory();
		getThirdGame();
		// 获取用户收藏彩种集合
		getUserFavoritesLotteryList();
	},
	methods: {
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(function () {
				this.isRouterAlive = true;
			});
		},
	},
};
</script>
<style lang="scss">
// 覆盖浏览器默认滚动条 chrome
::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background: hsla(0, 0%, 100%, 0.6);
}

::-webkit-scrollbar-track {
	border-radius: 0;
}

::-webkit-scrollbar-thumb {
	border-radius: 0;
	background-color: rgba(95, 95, 95, 0.4);
	transition: all 0.2s;
	border-radius: 0.5rem;

	&:hover {
		background-color: rgba(95, 95, 95, 0.7);
	}
}

html {
	overflow-y: auto;
	scrollbar-color: rgba(0, 0, 0, 0.397) transparent;
	scrollbar-track-color: rgba(0, 0, 0, 0.397);
	-ms-scrollbar-track-color: rgba(0, 0, 0, 0.397);
	scrollbar-width: thin;
}

#app {
	background-color: #edf0fa;
}

.image-wrapper {
	z-index: 1999;
	width: 100%;
	top: 0;
	left: 0;
	right: 0;
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	max-width: 600px;
	margin: auto;
	overflow: hidden;
	background-color: #a1d7fd;

	img {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue